import api from './api';

// ── Fee Schedule Items ──────────────────────────────────────────────────────

export const getFeeScheduleItems = () =>
  api.get('/api/v1/fee-schedule').then((r) => r.data.data);

export const createFeeScheduleItem = (data) =>
  api.post('/api/v1/fee-schedule', data).then((r) => r.data.data);

export const updateFeeScheduleItem = ({ id, ...data }) =>
  api.put(`/api/v1/fee-schedule/${id}`, data).then((r) => r.data.data);

export const deactivateFeeScheduleItem = (id) =>
  api.delete(`/api/v1/fee-schedule/${id}`).then((r) => r.data);

// ── Payer Contracted Rates ──────────────────────────────────────────────────

export const getPayerRates = (params) =>
  api.get('/api/v1/fee-schedule/payer-rates', { params }).then((r) => r.data.data);

export const createPayerRate = (data) =>
  api.post('/api/v1/fee-schedule/payer-rates', data).then((r) => r.data.data);

export const updatePayerRate = ({ id, ...data }) =>
  api.put(`/api/v1/fee-schedule/payer-rates/${id}`, data).then((r) => r.data.data);

export const deletePayerRate = (id) =>
  api.delete(`/api/v1/fee-schedule/payer-rates/${id}`).then((r) => r.data);
